import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/icons/checkcircle.svg'


const _hoisted_1 = { class: "layout-eoi" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "content"
}
const _hoisted_4 = {
  key: 0,
  class: "description"
}
const _hoisted_5 = {
  key: 1,
  class: "description"
}
const _hoisted_6 = { class: "back-map" }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 1,
  class: "spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["HeaderCustomer"], {
      estate: $setup.estate,
      hideAuthButtons: true
    }, null, 8, ["estate"]),
    _createElementVNode("div", _hoisted_2, [
      (!$setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "logo-box" }, [
              _createElementVNode("img", { src: _imports_0 })
            ], -1)),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "headline" }, "You’ve joined the Waitlist", -1)),
            ($setup.isLogged())
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, "You can view and edit your waitlist preferences at anytime by visiting the Waitlists section of your LotTrackr dashboard."))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _cache[0] || (_cache[0] = _createElementVNode("span", null, [
                    _createTextVNode("We’ll keep you informed about future releases at "),
                    _createElementVNode("br")
                  ], -1)),
                  _createElementVNode("span", null, _toDisplayString($setup.estate.title + "."), 1)
                ])),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("a", {
                class: "back",
                href: `/v2/estate/${$setup.estateId}`
              }, "Back to Map", 8, _hoisted_7)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8))
    ])
  ]))
}